export const CityDownloadApp = (props) => {
  const { downloadTitle, downloadImage, appStore } = props;
  return (
    <section id="meld-je-aan">
      <div className="banner-wrapper">
        <div className="banner-row">
          <div
            className="banner-cta__image"
            style={{
              backgroundImage: `url(${downloadImage.url})`,
            }}
            //
          ></div>
          <div>
            <div className="banner-headline">
              <h2 style={{ margin: 0 }}>{downloadTitle}</h2>
              <p>Download de app om te huren.</p>
              <div className="app-logos-banner" style={{ marginTop: '1rem' }}>
                {appStore.map((store) => (
                  <div>
                    <a href={store.link}>
                      <img
                        src={`${store.image.url}`}
                        className="appstorelogo"
                        alt={store.image.alternativeText}
                      ></img>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
